module.exports = __webpack_public_path__ + "img/caissedepargne.2e4f8844.jpg";